import { ModuleConfig, ModuleMapConfig } from '@schamburg-web/interfaces';

const snowplowRouteIcon = '/mapicons/plowroute.svg';

const mapModuleConfig: ModuleMapConfig = {
  layerIcon: snowplowRouteIcon,
  showOnMap: true,
  defaultEnabled: false,
  wmsMapLayer: {
    light: {
      server: import.meta.env.VITE_REACT_APP_GEOSERVERURL + '/wms?',
      args: {
        LAYERS: ['lake:snow_routes'],
        STYLES: ['lake:snow_routes'],
        SRS: 'EPSG:900913',
      },
    },
    dark: {
      server: import.meta.env.VITE_REACT_APP_GEOSERVERURL + '/wms?',
      args: {
        LAYERS: ['lake:snow_routes'],
        STYLES: ['lake:snow_routes_dark'],
        SRS: 'EPSG:900913',
      },
    },
  },
};

const moduleConfig: ModuleConfig = {
  moduleLabel: 'Snowplow Routes',
  name: 'snowplowroutes',
  mapConfig: mapModuleConfig,
};

export default moduleConfig;
